import axios from 'axios';
import { API_ROOT, ACCEPT_HEADER } from '../apiConfig';
export function searchCode(code, callBackFunc, errorHandler) {
    axios.post(`${API_ROOT}/scheduler/access`,
        {
            code
        },

        { withCredentials: true }, ACCEPT_HEADER).then((response) => {
            let { success, result } = response.data;
            if ((success || result) && callBackFunc) {
                callBackFunc(response);
            }
        }).catch((err) => {
            if (errorHandler) {
                errorHandler(err);
            } else {
                console.log(err);
            }
        });
    // RESPONSE of single location (skip location selection step)
    // available_dates: [],
    // data: [],
    // email_required: false,
    // payment_required: true,
    // result: true,

    // RESPONSE of multiple locations (location selection step)
    // {
    //     "result": true,
    //     "locations": [
    //         {
    //             "id": 524,
    //             "name": "3 Seasons Soothe"
    //         },
    //         {
    //             "id": 780,
    //             "name": "Ahmad Nwwww"
    //         },
    //         {
    //             "id": 936,
    //             "name": "NY Test"
    //         }
    //     ],
    //     "data": {}
    // }
}
export function getAvailableDates(locationId, callBackFunc, errorHandler) {
    axios.post(`${API_ROOT}/scheduler/slots`,
        {
            location_id: locationId
        },
        { withCredentials: true }, ACCEPT_HEADER).then((response) => {
            let { success, result } = response.data;
            if ((success || result) && callBackFunc) {
                callBackFunc(response);
            }
        }).catch((err) => {
            if (errorHandler) {
                errorHandler(err);
            } else {
                console.log(err);
            }
        });
}
export function book(payload, callBackFunc, errorHandler) {
    axios.post(`${API_ROOT}/scheduler/bookings`,
        {
            ...payload
        },
        { withCredentials: true }, ACCEPT_HEADER).then((response) => {
            let { success, result } = response.data;
            if ((success || result) && callBackFunc) {
                callBackFunc(response);
            }
        }).catch((err) => {
            if (errorHandler) {
                errorHandler(err);
            } else {
                console.log(err);
            }
        });
    // payload example: (employer pays)
    //   "location_id": 123,
    //   "slot_ids": [456, 457],
    //   "first_name": "Ahmad",
    //   "last_name": "Haidar",
    //   "provider_notes": "Please bring necessary equipment."
    // "email": "ahmad@gotocme.com",
    /********/
    // payload example: (employee pays or subsidized)
    // "credit_card": {
    //   "last_4": "4242",
    //   "stripe_id": "tok_visa_abc123",
    //   "name": "Ahmad Haidar",
    //   "exp_month": "12",
    //   "exp_year": "2026",
    //   "type": "visa",
    //   "brand": "visa",
    //   "default": true,
    //   "zip_code": "10001",
    //   "state": "NY",
    //   "apt_number": "5B",
    //   "street_address": "123 Broadway",
    //   "city": "New York"
    // }
}
export function saveEmail({ email, slot_ids }, callBackFunc, errorHandler) {
    axios.post(`${API_ROOT}/scheduler/slots/email_confirmation`,
        {
            email,
            slot_ids
        },
        { withCredentials: true }, ACCEPT_HEADER).then((response) => {
            let { success, result } = response.data;
            if ((success || result) && callBackFunc) {
                callBackFunc(response);
            }
        }).catch((err) => {
            if (errorHandler) {
                errorHandler(err);
            } else {
                console.log(err);
            }
        });
}